// GeoJSON layers and sources configuration
export const createGeoJSONSources = (mapList) => {
  const sources = {};

  // Add GeoJSON sources from mapList
  mapList.forEach((map, index) => {
    if (map.geojson && map.geojson.type === "FeatureCollection") {
      const sourceId = `geojson-${map._id || index}`;
      sources[sourceId] = {
        type: "geojson",
        data: map.geojson
      };
    }
  });

  return sources;
};

export const createGeoJSONLayers = (mapList) => {
  const layers = [];

  // Add GeoJSON layers from mapList
  mapList.forEach((map, index) => {
    if (map.geojson && map.geojson.type === "FeatureCollection") {
      const sourceId = `geojson-${map._id || index}`;
      const layerId = `geojson-layer-${map._id || index}`;

      // Add 3D extrusion layer
      layers.push({
        id: layerId + '3d',
        type: "fill-extrusion",
        source: sourceId,
        layout: { visibility: "visible" },
        paint: {
          'fill-extrusion-color': [
            'case',
            ['has', 'color'],
            ['get', 'color'],
            '#3bb2d0'
          ],
          "fill-extrusion-height": ["get", "height"],
          "fill-extrusion-base": ["get", "base_height"],
          "fill-extrusion-opacity": 0.9
        }
      });

      // Add name label layer
      layers.push({
        id: layerId + 'name',
        type: 'symbol',
        source: sourceId,
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['Noto Sans Regular'],
          'text-size': 14,
          'text-anchor': 'center',
          'text-offset': [0, 0],
          'text-allow-overlap': true,
          'text-ignore-placement': false,
          'visibility': 'visible'
        },
        paint: {
          'text-color': '#ffffff',
          'text-halo-color': '#000000',
          'text-halo-width': 2,
          'text-halo-blur': 1,
        },
      });

      // Add 2D outline layer
      layers.push({
        id: layerId + '2d',
        type: "line",
        source: sourceId,
        layout: { visibility: "visible" },
        paint: {
          "line-color": "#333",
          "line-width": 0.8
        }
      });
    }
  });

  return layers;
};

export const createGeoJSONLayerTree = (mapList) => {
  const layerTree = {};

  // Add GeoJSON layer tree from mapList
  mapList.forEach((map, index) => {
    if (map.geojson && map.geojson.type === "FeatureCollection") {
      const layerId = `geojson-layer-${map._id || index}`;

      if (!layerTree["geojson-data"]) {
        layerTree["geojson-data"] = {
          label: "High Definition Custom",
          layers: [],
          children: {}
        };
      }

      layerTree["geojson-data"].children[layerId] = {
        label: map.name || `GeoJSON ${index + 1}`,
        layers: [layerId + '3d', layerId + 'name', layerId + '2d']
      };
      layerTree["geojson-data"].layers.push(layerId + '3d', layerId + 'name', layerId + '2d');
    }
  });

  return layerTree;
};

export const createGeoJSONLayerVisibility = (mapList) => {
  const layerVisibility = {};

  // Add GeoJSON layer visibility from mapList
  mapList.forEach((map, index) => {
    if (map.geojson && map.geojson.type === "FeatureCollection") {
      const layerId = `geojson-layer-${map._id || index}`;
      layerVisibility[layerId + '3d'] = true;
      layerVisibility[layerId + 'name'] = true;
      layerVisibility[layerId + '2d'] = true;
    }
  });

  return layerVisibility;
}; 